import complexConfigurator from './complexConfigurator';
import configurator from './configurator';

/**
 * Ensures that a project exists
 */
export async function getOrCreateProject() {
  if (complexConfigurator.projectAdapter.hasProject()) {
    return complexConfigurator.projectAdapter.getProject();
  }

  return new Promise((resolve) => {
    // this will create a new project
    complexConfigurator.projectAdapter.update((project) => {
      // we're overriding the onSuccess callback for projectAdapter.update, so we manually call the updateSucceeded function
      // so that the data is properly set on the adapter model
      complexConfigurator.projectAdapter.updateSucceeded(project);
      resolve(project);
    });
  });
}

/**
 * Gets the current sku based on current selections; if sku cannot be determined, returns null
 */
export function getCurrentSku() {
  const ctaUrlProviderSku = complexConfigurator.callToActionUrlProvider.get('state').get('currentSku');
  if (ctaUrlProviderSku && ctaUrlProviderSku !== -1 && ctaUrlProviderSku.get('sku')) {
    return ctaUrlProviderSku.get('sku');
  }

  return null;
}

export async function ensureFullBleedTemplateOnProject(project) {
  // if we're already in DesignFirstFlow, just ignore this method; we assume that it already executed
  if (project.flowState === configurator.constants.FLOW_STATE.DESIGN_FIRST) {
    return project;
  }

  const sku = getCurrentSku();

  if (sku === null) {
    throw new Error('Unable to determine sku');
  }

  // construct a full bleed combo by pre-pending 'f_' to the sku
  const fullBleedCombo = `f_${sku}`;

  const newProps = {
    // add the design info to the project
    documentSource: {
      sourceType: 'design',
      data: fullBleedCombo,
    },
    // set the flowState to Design First so that the GPP will proceed to studio
    flowState: configurator.constants.FLOW_STATE.DESIGN_FIRST,
  };

  const newProject = { ...project, ...newProps };

  return new Promise((resolve) => {
    complexConfigurator.projectAdapter.update((updatedProject) => {
      // the "isDesignFirstFlow" prop is set when the projectAdapter is initialized, so we need to update it here
      complexConfigurator.projectAdapter.set(
        'isDesignFirstFlow',
        updatedProject.flowState === configurator.constants.FLOW_STATE.DESIGN_FIRST,
      );

      // the "shouldShowMatching" prop is set when callToActionUrlProvider is initialized, so we need to update it here
      // this ensures that the CTAUrlProvider will generate us a studio link rather than a gallery link
      complexConfigurator.callToActionUrlProvider.set(
        'shouldShowMatching',
        updatedProject.flowState === configurator.constants.FLOW_STATE.DESIGN_FIRST,
      );

      resolve(updatedProject);
    }, newProject);
  });
}
